import React, { useState } from "react";
import "./ServiceCards.css";
import { GoDotFill } from "react-icons/go";

const ServiceCards = ({ title, subtitle, services, end }) => {
    const [hoveredCard, setHoveredCard] = useState(null);

    return (
        <div className="service-cards-section">
            <h2 className="service-cards-title">{title}</h2>
            {subtitle && (
                <h2 className="service-cards-title">{subtitle}</h2>
            )}
            <div className="service-cards-grid">
                {services.map((service, i) => {
                    // Default icon fallback
                    const Icon = service.icon || GoDotFill;

                    return (
                        <div
                            key={i}
                            className="service-card"
                            onMouseEnter={() => setHoveredCard(`service-${i}`)}
                            onMouseLeave={() => setHoveredCard(null)}
                            style={
                                hoveredCard === `service-${i}`
                                    ? {
                                        transform: "translateY(-8px)",
                                        boxShadow: "0 12px 28px rgba(0,0,0,0.12)",
                                        borderColor: "#4F46E5",
                                    }
                                    : {}
                            }
                        >
                            <div className="service-card-content">
                                <div className="service-card-icon">
                                    {typeof Icon === "string" ? Icon : <Icon />}
                                </div>

                                <div className="service-card-text">
                                    {service.title && (
                                        <strong className="service-card-title">
                                            {service.title}
                                        </strong>
                                    )}

                                    {service.text && (
                                        <p className="service-card-subtitle">
                                            {service.text}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {end && (
                <h2>{end}</h2>
            )}
        </div>
    );
};

export default ServiceCards;
